export default function swDev() {
  function determineAppServerKey() {
    const vapidPublicKey =
      'BIaYD6v63hWtVvSjg19u9A6uzCxWDUOPUXNYJTGcj5GhH3q9pRhj8UwDB9fQWgZsXdtJQdDNS5_VKw7ess5R7mE';
    return urlBase64ToUint8Array(vapidPublicKey);
  }

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

  navigator.serviceWorker.register(swUrl).then((registration) => {
    return registration.pushManager.getSubscription().then((existingSubscription) => {
      // ✅ If a subscription exists, unsubscribe first then resubscribe
      if (existingSubscription) {
        return existingSubscription.unsubscribe().then(() => {
          return registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: determineAppServerKey(),
          });
        });
      }

      // ✅ No existing subscription — subscribe fresh
      return registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: determineAppServerKey(),
      });
    });
  });
}